// Branding-Context — Phase 13 Commit 11.
//
// Split out from BrandingProvider.tsx so the provider file stays
// react-refresh-clean (component-only export, non-component exports
// here). Runtime behaviour identical — the useBrandingTokens() hook
// and BrandingContext live here, the <BrandingProvider> component
// imports them.

import { createContext, useContext } from "react";
import { BRANDING_DEFAULTS, type BrandingTokens } from "@scrolly/branding";

export const BrandingContext = createContext<BrandingTokens>(BRANDING_DEFAULTS);

/**
 * Read the current V2 branding tokens. Fallback is BRANDING_DEFAULTS for
 * components mounted outside a provider (unit tests, Storybook-like
 * dev paths). The provider is always mounted at the viewer root in the
 * production page tree, so the fallback is defensive, not load-bearing.
 */
export function useBrandingTokens(): BrandingTokens {
  return useContext(BrandingContext);
}
